
<div class="text-center p-5" *ngIf="redirecting">
    <div class="spinner-border text-primary" role="status">
        <span class="sr-only">{{ 'pages.generic.loading' | translate }}</span>
    </div>
    <div class="p-3">
        <h3>Authenticating administrator access</h3>
    </div>
</div>  

<div class="row pt-5" *ngIf="dataLoaded">
    <div class="col-12"> 

        <ul class="nav nav-tabs">
            <li class="nav-item">
                <a class="nav-link" [ngClass]="{ 'active' : selectedTab === 'users' }" (click)="selectedTab = 'users'; selectedTabContext = 'list'" >Manage Users</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [ngClass]="{ 'active' : selectedTab === 'admins' }" (click)="selectedTab = 'admins'; selectedTabContext = 'list'">Manage Administrators</a>
            </li> 
        </ul>

    </div>
</div>


<div class="row pt-3" *ngIf="adminUsers && selectedTab === 'admins'">
    <div class="col-12"> 

        <ng-template #statusHelp> 
            If the user status is 'PROVISIONED' then they have received the activation email but they have not activated their account
        </ng-template>        
        
        <div class="row faketableheaderrow">
            <div class="col-3 faketableheader">
                {{ 'pages.generic.email' | translate }}
            </div>
            <div class="col-3 faketableheader">
                {{ 'pages.viewTenant.status' | translate }}  <fa-icon [icon]="['fas', 'question-circle']" class="p-1" placement="top" [ngbTooltip]="statusHelp" ></fa-icon>
            </div>
            <div class="col-3 faketableheader">
                {{ 'pages.viewTenant.lastLogin' | translate }}
            </div>
            <div class="col-3 faketableheader">
                {{ 'pages.viewTenant.actions' | translate }}
            </div>
        </div>

        <div class="row faketablerow" *ngFor="let admin of adminUsers">
            <div class="col-3 faketablecell">
                {{admin.profile.email}}
            </div>
            <div class="col-3 faketablecell centerme">
                {{admin.status}}
            </div>
            <div class="col-3 faketablecell centerme">
                {{admin.lastLogin | date: 'dd/MM/yyyy HH:mm'}}
            </div>
            <div class="col-3 faketablecell">
                <div ngbDropdown class="d-inline-block">
                    <button class="btn btn-info" id="dropdownMenu1" ngbDropdownToggle (click)="selectUser(admin.id)">Actions</button>
                    <div ngbDropdownMenu aria-labelledby="dropdownMenu1">
                        <button ngbDropdownItem (click)="downgradeUserFromAdmin(confirmModal, admin.id, admin.profile.email)">Remove Admin</button>
                        <button ngbDropdownItem *ngFor="let link of selectedUserLinks" (click)="userOperation(confirmModal, admin.id, link.operation, admin.profile.email)">{{link.name}}</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>


<div class="row pt-3" *ngIf="userUsers && selectedTab === 'users'">
    <div class="col-6 text-left" *ngIf="selectedTabContext === 'list'"> 
        <input type="text" class="form-control" name="filter" id="filter" placeholder="Filter..." aria-describedby="Filter" [(ngModel)]="userFilter" (keyup)="filterUsers($event);">
    </div>
    <div class="col-6 text-left" *ngIf="selectedTabContext === 'add'">
    </div>
    <div class="col-6 text-right"> 
        <span *ngIf="selectedTabContext === 'list'">
            <a (click)="toggleListAdd('add');" class="btn btn-primary" data-placement="top" title="{{ 'pages.user.adminAddUserDesc' | translate }}">{{ 'pages.viewTenant.addUser' | translate }}</a>
        </span>
        <span *ngIf="selectedTabContext === 'add'">
            <a (click)="toggleListAdd('list')" class="btn btn-primary">{{ 'pages.viewTenant.listUsers' | translate }}</a>
        </span>
    </div>

    <div class="col-12" *ngIf="selectedTabContext === 'list'"> 

        <ng-template #statusHelp> 
            If the user status is 'PROVISIONED' then they have received the activation email but they have not activated their account
        </ng-template>     

        <div class="row faketableheaderrow">
            <div class="col-3 faketableheader">
                <span class="click" (click)="sortUsers('email')">{{ 'pages.generic.email' | translate }}</span>
            </div>
            <div class="col-3 faketableheader">
                <span class="click" (click)="sortUsers('status')">{{ 'pages.viewTenant.status' | translate }}</span> <fa-icon [icon]="['fas', 'question-circle']" class="p-1" placement="top" [ngbTooltip]="statusHelp" ></fa-icon>
            </div>
            <div class="col-3 faketableheader">
                <span class="click" (click)="sortUsers('lastLogin')">{{ 'pages.viewTenant.lastLogin' | translate }}</span>
            </div>
            <div class="col-3 faketableheader">
                {{ 'pages.viewTenant.actions' | translate }}
            </div>
        </div>

        <div class="row faketablerow" *ngFor="let user of displayedUsers">
            <div class="col-3 faketablecell">
                {{user.profile.email}}
            </div>
            <div class="col-3 faketablecell centerme">
                {{user.status}}
            </div>
            <div class="col-3 faketablecell centerme">
                {{user.lastLogin | date: 'dd/MM/yyyy HH:mm'}}
            </div>
            <div class="col-3 faketablecell centerme">
                <div ngbDropdown class="d-inline-block">
                    <button class="btn btn-info" id="dropdownMenu1" ngbDropdownToggle (click)="selectUser(user.id)">Actions</button>
                    <div ngbDropdownMenu aria-labelledby="dropdownMenu1">
                        <button ngbDropdownItem (click)="editUser(user.id)">Edit User</button>
                        <button ngbDropdownItem (click)="upgradeUserToAdmin(confirmModal, user.id, user.profile.email)">Make Admin</button>
                        <button ngbDropdownItem *ngFor="let link of selectedUserLinks" (click)="userOperation(confirmModal, user.id, link.operation, user.profile.email)">{{link.name}}</button>
                    </div>
                </div>
            </div>
        </div>

    </div> 

    <div class="col-12" *ngIf="selectedTabContext === 'add'"> 

        <h5>{{ 'pages.viewTenant.addUser' | translate }}</h5>

        <div class="row">
            <div class="col-12">

                <ul>
                    <li>Enter user's name and email address</li>
                    <li>Select 'Activate' under the 'UnifiedGlobalPortal' application to activate portal access</li>
                    <li>Select the required roles from the list that will appear</li>
                    <li>Select 'Add' to complete user registration</li>
                    <li>The user will receive an email from Okta to activate their account and setup their multifactor authentication</li>
                    <li>{{ 'pages.user.adminMandatoryRoleDesc' | translate }}</li>
                </ul>

            </div>
        </div>

        <div class="grouping">
            <form [formGroup]="userForm" (submit)="addUser();">
                <div class="form-row">

                    <div class="row" *ngIf="!editting">
                        <div class="col-12 mb-3">
                            <label for="query">{{ 'pages.generic.firstName' | translate }}</label>
                            <input type="text" formControlName="firstName" [ngClass]="{ 'is-invalid': submittedUser && uf.firstName.errors }"  class="form-control" name="firstName" aria-describedby="firstName" placeholder="First name">
                            <div *ngIf="submittedUser && uf.firstName.errors" class="invalid-feedback">
                                <div *ngIf="uf.firstName.errors.required">{{ 'pages.generic.firstNameReq' | translate }}</div>
                            </div>
                        </div>
                        <div class="col-12 mb-3">
                            <label for="query">{{ 'pages.generic.lastName' | translate }}</label>
                            <input type="text" formControlName="lastName" [ngClass]="{ 'is-invalid': submittedUser && uf.lastName.errors }" class="form-control" name="lastName" aria-describedby="lastName" placeholder="Last name">
                            <div *ngIf="submittedUser && uf.lastName.errors" class="invalid-feedback">
                                <div *ngIf="uf.lastName.errors.required">{{ 'pages.generic.lastNameReq' | translate }}</div>
                            </div>
                        </div>
                        <div class="col-12 mb-3">
                            <label for="query">{{ 'pages.generic.email' | translate }}</label>
                            <input type="text" formControlName="email" [ngClass]="{ 'is-invalid': submittedUser && uf.email.errors }" class="form-control" name="email" aria-describedby="email" placeholder="Email">
                            <div *ngIf="submittedUser && uf.email.errors" class="invalid-feedback">
                                <div *ngIf="uf.email.errors.required">{{ 'pages.generic.emailReq' | translate }}</div>
                                <div *ngIf="uf.email.errors.email">{{ 'pages.generic.emailValid' | translate }}</div>
                            </div>
                        </div>
                    </div>


                    <div class="row" *ngIf="editting">
                        <div class="col-12 mb-3">
                            <label for="query">First name</label>
                            {{edittingUser.profile.firstName}}
                        </div>
                        <div class="col-12 mb-3">
                            <label for="query">Last name</label>
                            {{edittingUser.profile.lastName}}
                        </div>
                        <div class="col-12 mb-3">
                            <label for="query">Email</label>
                            {{edittingUser.profile.email}}
                        </div>
                    </div>

                    <div class="col-12 mb-3">
                        <div class="row">
                            <div class="col-3" *ngFor="let app of selectedTenantApps">
                                <div class="card" style="width: 18rem;">
                                    <div class="card-body text-center">
                                        <h5 class="card-title"> <img src="{{app.logo[0].href}}" style="width:200px;" /> {{app.name}}</h5>
                                        <p class="card-text">{{app.created | date: 'dd/MM/yyyy HH:mm'}}</p>
                                        <a (click)="activateAppForUser(app)" routerLinkActive="router-link-active" *ngIf="!activatedUserApps.includes(app)" class="btn btn-primary" data-placement="top" title="{{ 'pages.user.adminActivateDesc' | translate }}">{{ 'pages.generic.activate' | translate }}</a>
                                        <a (click)="deactivateAppForUser(app)" routerLinkActive="router-link-active" *ngIf="activatedUserApps.includes(app)" class="btn btn-primary">{{ 'pages.generic.deactivate' | translate }}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-12 mb-3">
                        <label for="query">{{ 'pages.viewTenant.availRoles' | translate }}</label>
                        <div *ngFor="let r of availableUserRoles" class="pl-2">
                            <input type="checkbox" [id]="r.id" [checked]="selectedUserRoleIds.includes(r.id)" (change)="selectRole($event, r.id)">
                            <label class="pl-2">{{r.appName}} - {{r.name}}</label>

                            <app-help *ngIf="r.name === 'Access_SOC_Role'" message="{{'pages.user.accessSOCDesc' | translate}}"></app-help>
                            <app-help *ngIf="r.name === 'Access_CSOC_Role'" message="{{'pages.user.accessCSOCDesc' | translate}}"></app-help>
                            <app-help *ngIf="r.name === 'Create_Change_Request'" message="{{'pages.user.createCRDesc' | translate}}"></app-help>
                            <app-help *ngIf="r.name === 'Create_Service_Request'" message="{{'pages.user.createSRDesc' | translate}}"></app-help>
                            <app-help *ngIf="r.name === 'Create_Incident'" message="{{'pages.user.createIncDesc' | translate}}"></app-help>
                            <app-help *ngIf="r.name === 'Access_Change_Request'" message="{{'pages.user.accessCRDesc' | translate}}"></app-help>
                            <app-help *ngIf="r.name === 'Access_Service_Request'" message="{{'pages.user.accessSRDesc' | translate}}"></app-help>
                            <app-help *ngIf="r.name === 'Access_Incident'" message="{{'pages.user.accessIncDesc' | translate}}"></app-help>
                        </div>
                    </div> -->
                    <div class="col-12 mb-3">
                        <h4 for="query">{{ 'pages.viewTenant.availRoles' | translate }}</h4>

                        <h6>SOC User</h6>
                        <div *ngFor="let r of availableUserRoles" class="pl-2">
                            <ng-container *ngIf="r.name == 'Access_SOC_Role'">
                                
                                 <input type="checkbox" [id]="r.id" [checked]="selectedUserRoleIds.includes(r.id)" (change)="selectRole($event, r.id)">
                            <label class="pl-2">{{r.appName}} - {{r.name}}</label>

                            </ng-container>
                            <ng-container *ngIf="r.name == 'Access_SOC_Reports'">
                                
                                 <input type="checkbox" [id]="r.id" [checked]="selectedUserRoleIds.includes(r.id)" (change)="selectRole($event, r.id)">
                            <label class="pl-2">{{r.appName}} - {{r.name}}</label>

                            </ng-container>
                            
                            <app-help *ngIf="r.name === 'Access_SOC_Role'" message="{{'pages.user.accessSOCDesc' | translate}}"></app-help>
                        </div>

                        <h6 style="margin-top:10px;">CyberSOC User</h6>
                        <div *ngFor="let r of availableUserRoles" class="pl-2">
                            <ng-container *ngIf="r.name == 'Access_CSOC_Role'">

                                 <input type="checkbox" [id]="r.id" [checked]="selectedUserRoleIds.includes(r.id)" (change)="selectRole($event, r.id)">
                            <label class="pl-2">{{r.appName}} - {{r.name}}</label>

                            </ng-container>
                            <ng-container *ngIf="r.name == 'Access_CSOC_Reports'">

                                 <input type="checkbox" [id]="r.id" [checked]="selectedUserRoleIds.includes(r.id)" (change)="selectRole($event, r.id)">
                            <label class="pl-2">{{r.appName}} - {{r.name}}</label>

                            </ng-container>

                            <app-help *ngIf="r.name === 'Access_CSOC_Role'" message="{{'pages.user.accessCSOCDesc' | translate}}"></app-help>
                        </div>

                        <h6 style="margin-top:10px;">Report Viewing Permissions</h6>
                        <div *ngFor="let r of availableUserRoles" class="pl-2">
                            <ng-container *ngIf="r.name == 'Access_Restricted_Reports'">

                                 <input type="checkbox" [id]="r.id" [checked]="selectedUserRoleIds.includes(r.id)" (change)="selectRole($event, r.id)">
                            <label class="pl-2">{{r.appName}} - {{r.name}}</label>

                            </ng-container>
                            <ng-container *ngIf="r.name == 'Access_Internal_Reports'">

                                 <input type="checkbox" [id]="r.id" [checked]="selectedUserRoleIds.includes(r.id)" (change)="selectRole($event, r.id)">
                            <label class="pl-2">{{r.appName}} - {{r.name}}</label>

                            </ng-container>
                            <ng-container *ngIf="r.name == 'Access_Confidential_Reports'">

                                 <input type="checkbox" [id]="r.id" [checked]="selectedUserRoleIds.includes(r.id)" (change)="selectRole($event, r.id)">
                            <label class="pl-2">{{r.appName}} - {{r.name}}</label>

                            </ng-container>
                        </div>

                        <h6 style="margin-top:10px;">Permitted Actions</h6>
                        <div *ngFor="let r of availableUserRoles" class="pl-2">
                            <ng-container *ngIf="r.name == 'Access_Change_Request'">

                                 <input type="checkbox" [id]="r.id" [checked]="selectedUserRoleIds.includes(r.id)" (change)="selectRole($event, r.id)">
                            <label class="pl-2">{{r.appName}} - {{r.name}}</label>

                            </ng-container>
                            <ng-container *ngIf="r.name == 'Create_Change_Request'">

                                 <input type="checkbox" [id]="r.id" [checked]="selectedUserRoleIds.includes(r.id)" (change)="selectRole($event, r.id)">
                            <label class="pl-2">{{r.appName}} - {{r.name}}</label>

                            </ng-container>
                            <ng-container *ngIf="r.name == 'Access_Service_Request'">

                                 <input type="checkbox" [id]="r.id" [checked]="selectedUserRoleIds.includes(r.id)" (change)="selectRole($event, r.id)">
                            <label class="pl-2">{{r.appName}} - {{r.name}}</label>

                            </ng-container>
                            <ng-container *ngIf="r.name == 'Create_Service_Request'">

                                 <input type="checkbox" [id]="r.id" [checked]="selectedUserRoleIds.includes(r.id)" (change)="selectRole($event, r.id)">
                            <label class="pl-2">{{r.appName}} - {{r.name}}</label>

                            </ng-container>
                            <ng-container *ngIf="r.name == 'Access_Incident'">

                                 <input type="checkbox" [id]="r.id" [checked]="selectedUserRoleIds.includes(r.id)" (change)="selectRole($event, r.id)">
                            <label class="pl-2">{{r.appName}} - {{r.name}}</label>

                            </ng-container>
                            <ng-container *ngIf="r.name == 'Create_Incident'">

                                 <input type="checkbox" [id]="r.id" [checked]="selectedUserRoleIds.includes(r.id)" (change)="selectRole($event, r.id)">
                            <label class="pl-2">{{r.appName}} - {{r.name}}</label>

                            </ng-container>

                            <app-help *ngIf="r.name === 'Create_Change_Request'" message="{{'pages.user.createCRDesc' | translate}}"></app-help>
                            <app-help *ngIf="r.name === 'Create_Service_Request'" message="{{'pages.user.createSRDesc' | translate}}"></app-help>
                            <app-help *ngIf="r.name === 'Create_Incident'" message="{{'pages.user.createIncDesc' | translate}}"></app-help>
                            <app-help *ngIf="r.name === 'Access_Change_Request'" message="{{'pages.user.accessCRDesc' | translate}}"></app-help>
                            <app-help *ngIf="r.name === 'Access_Service_Request'" message="{{'pages.user.accessSRDesc' | translate}}"></app-help>
                            <app-help *ngIf="r.name === 'Access_Incident'" message="{{'pages.user.accessIncDesc' | translate}}"></app-help>

                        </div>
                    </div>
                
                    <div *ngIf="editting">
                        <button class="btn btn-primary" type="submit" >{{ 'pages.generic.update' | translate }}</button>
                        <button class="btn btn-primary" (click)="resetEdit();" >{{ 'pages.generic.cancel' | translate }}</button>
                    </div>

                    <div *ngIf="!editting">
                        <button class="btn btn-primary" type="submit" >{{ 'pages.generic.add' | translate }}</button>
                        <button class="btn btn-primary" (click)="resetUser();" >{{ 'pages.generic.cancel' | translate }}</button>
                    </div>

                </div>
            </form>
        </div>
    </div>

</div>




<ng-template #confirmModal let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Confirmation</h4>
        <button type="button" class="close" aria-label="Close" (click)="d()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="text-align: center">
        <form>  
            <p>Are you sure you want to <b>{{operationDisplay}}</b> for <b>{{userDisplay}}?</b></p>
            <div class="form-group">
                <button type="button" class="btn btn-primary" (click)="actionUserOperation(userId, operation, operationDisplay, userDisplay); d();">Confirm</button>
                <button type="button" class="btn btn-primary" (click)="d()"> Cancel</button>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #roleErrorWindow let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title"> Roles</h4>
        <button type="button" class="close" aria-label="Close" (click)="d()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="text-align: center">
        <form>
            <p>Please assign your new user either or both of Access_CSOC_Role and/or Access_SOC_Role as applicable.</p>
            
            <br/>
            <br/>

            <div class="form-group">
                <button type="button" class="btn btn-primary" (click)="d()">Close</button>
            </div>
        </form>
    </div>
</ng-template>